module.exports = __webpack_public_path__ + "static/media/disc-drive.dab15a4d.svg";